<template>
  <div class="intelligentAgriculture-page">
    <!-- 智慧农业 -->
    <div class="haeder-container blackStatic" style="height:141px;">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main">
			<div class="main-bunner-img">
         <h2 style="font-size: 56px;
    font-weight: 500;
    position: absolute;
    color: #fff;
    left: 15%;
    top: 331px;width: 800px;
    text-align: left;">数字渔场解决方案</h2>
                <h2 style="font-size: 42px;
    font-weight: 500;
    position: absolute;
    color: #fff;
    left: 15%;
    top: 432px;width: 800px;
    text-align: left;">Digital fishery solutions</h2>
			</div>

       <div class="maim-module-03">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-text2">
						<h2 style="text-align: left;">百倍云种植养殖微气象</h2>
            <h2 style="text-align: left;">闭环控制系统</h2>
						<div class="segmentation" style="text-align: left;">
							<img src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							可视化大屏实时同步展示种养殖环境数据， 通过数据中心及时调控科学合理的环境数据 远程联动控制微闭环种植养殖环境
						</div>
					</div>
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/digitalFishery/img1.png" class="img-model">
					</div>
				</div>
			</div>
			
      <!-- 模块10 -->
			<div class="maim-module-02">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/digitalFishery/img2.png" class="img-model">
					</div>
					<div class="maim-module-02-center-text2">
						<h2>数字渔场一张图</h2>
						<div class="segmentation">
							<img style="float:right;" src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							池塘养殖气象气候监测、养殖尾水处理 水质参数、设备运行参数在线实时监测	</div>
					</div>
				</div>
			</div>
      <div class="maim-module-03">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-text2">
						<h2 style="text-align: left;">水质处理手动、定时、联动、</h2>
             <h2 style="text-align: left;"> 自动控制功能</h2>
						<div class="segmentation" style="text-align: left;">
							<img src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">池塘养殖气象气候监测、养殖尾水处理 水质参数、设备运行参数在线实时监测</div>
					</div>
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/digitalFishery/img3.png" class="img-model">
					</div>
				</div>
			</div>
			<!-- 模块4 -->
			<div class="maim-module-02">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/digitalFishery/img4.png" class="img-model">
					</div>
					<div class="maim-module-02-center-text2">
						<h2>历史、实时数据分析</h2>
						<div class="segmentation">
							<img style="float:right;" src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							实时分析各点位传感器参数变化情况， 可视化界面更直观远程调控响应位置设 备运行状态及配置参数，提高生产效率
						</div>
					</div>
				</div>
			</div>
			<!-- 模块5 -->
			<div class="maim-module-03">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-text2">
						<h2 style="text-align: left;">治理点GIS综合展示</h2>
						<div class="segmentation" style="text-align: left;">
							<img src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
						各治理点展示信息包括设备采集数据和基础数据 （面积、负责人信息、尾水处理设施照片）、 视频监控和人工巡检数据等。
						</div>
					</div>
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/digitalFishery/img5.png" class="img-model2">
					</div>
				</div>
			</div>
			<!-- 模块6 -->
			<div class="maim-module-02">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/digitalFishery/img6.png" class="img-model2">
					</div>
					<div class="maim-module-02-center-text2">
						<h2>水质监测数据分析管理</h2>
						<div class="segmentation">
							<img style="float:right;" src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							对水质监测实时数据进行分析，根据历史数据分 析及预设阈值判断监测指标是否处于正常范围， 当指标偏离正常范围时通过界面告警、短信、 APP推送消息、语音电话通知、本地声光提醒等 方式进行告警，还可根据配置自动调用水质调控 设备控制功能对水质进行调控
						</div>
					</div>
				</div>
			</div>
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style>
.haeder-container {
	width: 100%;
	height: 129px;
	margin: 0 auto;
	background-color: #030512;
}

/* .header-page {
	height: 70px;
	line-height: 70px;
	padding: 0 100px;
}

.header-left-container {
	float: left;
}

.header-logo {
	width: 160px;
	height: 30px;
	float: left;
	position: relative;
	top: 15px;
	cursor: pointer;
}

.header-page .header-left-container .header-logo img {
	width: 100%;
	height: 100%;
	display: block;
}

.header-page .header-left-container .header-action-line {
	float: left;
	width: 1px;
	height: 21px;
	display: inline-block;
	position: relative;
	top: 24px;
	margin: 0 20px;
	background: #fff;
} */

div:after,
li:after,
ul:after {
	clear: both;
	content: "";
	width: 0;
	height: 0;
	display: block;
	visibility: hidden;
}

/* .header-page .header-left-container .header-describe {
	float: left;
	font-size: 16px;
	color: #f1f3f8;
}

.nav-page {
	height: 60px;
	line-height: 60px;
	padding: 0 150px 0 100px;
	border-top: 1px solid rgba(40, 127, 172, .3);
	border-bottom: 1px solid rgba(40, 127, 172, .3);
	z-index: 1000;
}

.nav-page .nav-left-container {
	z-index: 1000;
	float: left;
}

.nav-page .nav-left-container .nav-list-container .nav-item-container:not(:last-child) {
	margin-right: 145px;
}

.nav-page .nav-left-container .nav-list-container .nav-item-container {
	float: left;
	font-size: 20px;
	color: #fff;
	position: relative;
	cursor: pointer;
}

.nav-page .nav-left-container .nav-list-container .nav-item-container .routerLink {
	font-size: 18px;
	color: #fff;
}

.nav-page .nav-right-container {
	z-index: 1000;
	float: right;
}

.nav-page .nav-right-container .jumpLink {
	color: #fff;
	font-size: 20px;
	display: block;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: horizontal;
	-webkit-box-direction: normal;
	-ms-flex-direction: row;
	flex-direction: row;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
}

.nav-page .nav-right-container .logo {
	margin-right: 26px;
}

.nav-page .nav-right-container .logo img {
	display: block; 
}*/
/* CSS Document */
*{
    margin:0;
    padding:0;
}
html, body, div, span, object, iframe,h1, h2, 
h3, h4, h5, h6, p, blockquote, pre,abbr, address, cite, code,del, dfn, 
em, img, ins,kbd, q, samp,small, strong, sub, sup, var,b, i,dl, dt, dd, 
ol, ul, li,fieldset, form, label, legend,table, caption, tbody, 
tfoot,thead,tr, th, td,article, aside, canvas, details, figcaption, 
figure, footer, header, hgroup, menu, nav, section, summary,time, mark, 
audio, video {
    margin:0;
    padding:0;
    border:0;
    outline:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    outline-style:none;
}
 
body {
    line-height:1;
}
ol, ul{
    text-decoration: none;
    list-style: none;
}
a{
    margin:0;
    padding:0;
    border:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    text-decoration:none;
    outline-style:none;
}
a:hover,a:focus{
    text-decoration:none;
    outline-style:none;
    }
table {
    border-collapse:collapse;
    border-spacing:0;
}
input, select {
    vertical-align:middle;
}
.clear{
    clear: both;
}







/* 媒体查询 */
@media all and (max-width: 1400px) and (min-width: 820px) {
	.main-bunner-img {
		width: 100%;
		height: 600px !important;
		background-image: url(~@/assets/img/caseDetails/digitalFishery/banner.png);
		background-repeat: no-repeat;
		background-size: contain;
	}
}
.main-bunner-img {
	width: 100%;
	height: 800px;
	background-image: url(~@/assets/img/caseDetails/digitalFishery/banner.png);
	background-repeat: no-repeat;
	background-size: contain;
}

.maim-module-01 {
	width: 100%;
	height: 700px;
	background: rgba(255, 255, 255, 1);
	display: flex;
	align-items: center;
}

.maim-module-01-center {
	width: 1200px;
	margin: 0 auto;
}

.maim-module-01-center-text {
	width: 1200px;
	height: 180px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
}

.maim-module-02 {
	width: 100%;
	height: 700px;
	background: #FCF9FC;
	display: flex;
	align-items: center;
}

.maim-module-02-center {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}

.maim-module-02-center-img {
	width: 670px;
	height: 377px;
}

.maim-module-02-center-text2 {
	width: 460px;
	height: 377px;
	display: flex;
  flex-direction: column;
  padding-top: 72px;

}

.maim-module-02-center-text2 h2 {
	width: 460px;
	height: 45px;
	text-align: justify;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #2CB1EA;
	line-height: 45px;
	margin-top: -6px;
	margin-bottom: 15px;
}

.segmentation {
	width: 460px;
	height: 5px;
	text-align: right;
	margin-top: 5px;
	margin-bottom: 20px;
}

.text02 {
	width: 460px;
	height: 216px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
  line-height: 36px;
  text-align: left;
}

.maim-module-03 {
	width: 100%;
	height: 700px;
	background: #FFFEFF;
	display: flex;
	align-items: center;
}

.img-model {
	width: 670px;
	height: 388px;
}

.bottom {
	width: 100%;
	height: 1114px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/bj.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.bottom-center {
	width: 1040px;
	margin: 0 auto;
}

h3 {
	width: 1040px;
	height: 45px;
	text-align: center;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(51, 51, 51, 1);
	line-height: 45px;
	padding-top: 63px;
}

.separation-text {
	margin-top: 25px;
	display: flex;
	justify-content: center;
}

.separation-text-01 {
	width: 127px;
	height: 2px;
	text-align: center;
	background: rgba(51, 51, 51, 1);
	opacity: 0.49770000000000003;
}

.list {
	margin-top: 44px;
  text-align: left;
}

.list-ico {
	display: inline-block;
	width: 20px;
	height: 20px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/Group 14.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.list-text {
	display: inline-block;
	width: 848px;
	height: 36px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
  margin-left: 20px;
}

.bottom-center-img {
	width: 1040px;
	height: 616px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/Group 18.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}



.img-model2{
      position: relative;
    bottom: 100px;
        width: 600px;
    height: auto;
}

</style>